{
  "title": "Protection from Evil and Good",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level abjuration",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (holy water or powdered silver and iron, which the spell consumes)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Until the spell ends, one willing creature you touch is protected against certain types of creatures: aberrations, celestials, elementals, fey, fiends, and undead.",
    "The protection grants several benefits. Creatures of those types have disadvantage on attack rolls against the target. The target also can't be charmed, frightened, or possessed by them. If the target is already charmed, frightened, or possessed by such a creature, the target has advantage on any new saving throw against the relevant effect."
  ],
  "spellLists": ["cleric", "druid", "eldritch-knight", "paladin", "warlock", "wizard"]
}
